import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          customerId: Yup.string()
                                                       .required('Required'),
                                          items: Yup.array(),
                                      });
